AppTabs.createTab( {
name: 'qa-flags',
icon: 'list-alt',
text: 'QA Flags',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-qa-flags',

		readTableName: 	'tblQAFlags',
		editTableName: 	'tblQAFlags',
		primaryKey: 	'QAFlagID',

		hasColumnFilters: 	true,
		canSearch: 			true,
		canSort:			true,
		paging:				false,

		actionData:			'datatable',
		actionAutofill: 	'datatable_autofill',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		fields: [
			{
				label: 		'QA Flag',
				columnName: 'QAFlag',
				isEditable: true,
				order: 		'asc',
			},
			{
				label: 		'QA Flag Description',
				columnName: 'QAFlagDescription',
				isEditable: true,
			},
			{
				label: 		'Certification Number',
				columnName: 'QAFlagCertificationNumber',
				isEditable: true,
			}
		],

	});
}});